import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import GeneralHelper from '../general';

const useIsMobile = () => {
	const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth < 800 : false);
	const location = useLocation();
	const query = GeneralHelper.getParamsFromUrl();

	useEffect(() => {
		let timeout;
		const getWindowSize = () => {
			clearTimeout(timeout);
			timeout = setTimeout(() => {
				setIsMobile(window.innerWidth < 800);
			}, 100);
		};

		getWindowSize();

		window.addEventListener('resize', getWindowSize);
		window.addEventListener('load', getWindowSize);

		return () => {
			window.removeEventListener('resize', getWindowSize);
			window.removeEventListener('load', getWindowSize);
			clearTimeout(timeout);
		};
	}, [location.pathname, query]);

	return isMobile;
};

export default useIsMobile;